export default __webpack_public_path__ + "static/media/Hair_15_F_C5.ccfe9919.svg";